// extracted by mini-css-extract-plugin
module.exports = {"search-keyword__wrapper":"search-keyword__wrapper"};